import React from 'react'
import {  Card, CardContent, Grid, IconButton, Typography } from '@mui/material'
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import { Link } from 'react-router-dom';
//import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
// import { useOktaAuth } from '@okta/okta-react';
//mport { useMsal } from "@azure/msal-react";

const CardComponent = ({data,footer=false}) => {
  // const {  authState } = useOktaAuth();
  // let adminUser = authState?.accessToken?.claims?.usergroups?.includes("ConfigToolAdmin");

  //const { instance }  = useMsal();
  //const accounts      = instance.getAllAccounts();
  //let adminUser       = accounts[0]?.idTokenClaims?.groups.includes("bc07e057-b44f-40df-ba4f-251acff402e8");

  return (
    <>
      {/* <Card sx={{backgroundColor:'#ffffff', minHeight:`${adminUser && data.type === 'Config' ? '297px' : !adminUser && data.type === 'Generate' ? '230px' : 'auto' } `}}>  */}
      <Card sx={{backgroundColor:'#ffffff'}}>
        <CardContent>
          <Typography variant={"h4"} sx={{mb:3}}>
            {data.type}
          </Typography>
          {data?.links?.map(element => (
            <Grid className='cardComp' container justifyContent="space-between" alignItems="center">
              <Grid item xs={10.5}>
                <Grid 
                  container
                  direction="row"
                  alignItems="center"
                  justifyContent="flex-start"
                >
                  <IconButton size='small' color="inherit">{element?.icon}</IconButton>
                  <Typography>{element.text}</Typography>
                </Grid>
              </Grid>
              <Grid item xs={1.5}>
                <IconButton
                  component={Link}
                  to={element.link}
                  color="inherit"
                  size='small'
                ><KeyboardArrowRightRoundedIcon />
                </IconButton>
              </Grid>
            </Grid>
          ))}
          {/* {footer &&
              <Grid
                className='cardCompFooter' container justifyContent="space-between" alignItems="center"
              >
                <Grid item xs={12}>
                  <Grid 
                    container
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <IconButton size='small' component={Link} to={'/config/add-project'} color='inherit'><AddCircleOutlineRoundedIcon /></IconButton>
                    <Typography variant="body2">Add New Project</Typography>
                    </Grid>
                </Grid>
              </Grid>
          } */}
          </CardContent>
        </Card>
    </>
  )
}

export default CardComponent